import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiSceleton',
  props: {
  class: {
    type: String as PropType<string>,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "ai-sceleton" }, null, -1)
  ]), 2))
}
}

})